import React, { useEffect, useState } from 'react';
import { Phone, Menu, X, Mail } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
const navLinks = [{
  label: 'Home',
  href: '#inicio'
}, {
  label: 'Gallery',
  href: '#galeria'
}, {
  label: 'Services',
  href: '#servicios'
}, {
  label: 'Areas',
  href: '#areas'
}, {
  label: 'Reviews',
  href: '#testimonios'
}, {
  label: 'Contact',
  href: '#contacto'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleNavClick = (href: string) => {
    setIsMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-black/95 backdrop-blur-sm shadow-md py-2 border-b border-brand-gold/10' : 'bg-transparent py-3'}`} data-id="element-101">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-102">
          {/* Logo */}
          <div className="flex-shrink-0 overflow-hidden" data-id="element-103">
            <img src="https://cdn.magicpatterns.com/uploads/hvEhkqVeZX92wrPFZpT8uE/Photoroom_20260407_091309.png" alt="EITHAN Landscaping & Junk Removal" className={`transition-all duration-300 brightness-0 invert max-w-[140px] sm:max-w-[180px] md:max-w-[220px] ${isScrolled ? 'h-10 sm:h-12' : 'h-12 sm:h-14 md:h-16'}`} data-id="element-104" />
          </div>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-1" data-id="element-105">
            {navLinks.map(link => <button key={link.href} onClick={() => handleNavClick(link.href)} className="px-3 py-2 text-sm font-medium text-gray-300 hover:text-brand-gold transition-colors rounded-lg hover:bg-white/5" data-id="element-106">
                {link.label}
              </button>)}
          </nav>

          {/* Right side: email + phone + hamburger */}
          <div className="flex items-center gap-2 sm:gap-3" data-id="element-107">
            <a href="mailto:diegolucasandres3@gmail.com" className="hidden md:inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-brand-gold border border-brand-gold/30 rounded-full hover:bg-brand-gold/10 transition-colors" data-id="element-108">
              <Mail size={16} data-id="element-109" />
              <span className="hidden xl:inline" data-id="element-110">Email</span>
            </a>
            <a href="tel:4233203426" className="inline-flex items-center gap-2 px-4 py-2 sm:px-5 sm:py-2.5 rounded-full font-bold transition-colors bg-brand-gold text-black hover:bg-brand-goldLight text-sm sm:text-base" data-id="element-111">
              <Phone size={16} data-id="element-112" />
              <span className="hidden sm:inline" data-id="element-113">423-320-3426</span>
            </a>
            {/* Mobile hamburger */}
            <button onClick={() => setIsMobileOpen(!isMobileOpen)} className="lg:hidden p-2 text-white hover:text-brand-gold transition-colors" aria-label="Toggle menu" data-id="element-114">
              {isMobileOpen ? <X size={24} data-id="element-115" /> : <Menu size={24} data-id="element-116" />}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-117">
        {isMobileOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.2
      }} className="fixed inset-x-0 top-[60px] z-40 bg-brand-black/98 backdrop-blur-md border-b border-brand-gold/10 lg:hidden" data-id="element-118">
            <nav className="max-w-7xl mx-auto px-4 py-6 flex flex-col gap-1" data-id="element-119">
              {navLinks.map(link => <button key={link.href} onClick={() => handleNavClick(link.href)} className="w-full text-left px-4 py-3 text-lg font-medium text-gray-200 hover:text-brand-gold hover:bg-white/5 rounded-lg transition-colors" data-id="element-120">
                  {link.label}
                </button>)}
              <div className="border-t border-white/10 mt-4 pt-4" data-id="element-121">
                <a href="mailto:diegolucasandres3@gmail.com" className="flex items-center gap-3 px-4 py-3 text-brand-gold hover:bg-white/5 rounded-lg transition-colors text-sm" data-id="element-122">
                  <Mail size={18} data-id="element-123" />
                  diegolucasandres3@gmail.com
                </a>
              </div>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </>;
}